import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box } from '@mui/material';
import dayjs from 'dayjs';

export default function LogsDatePickerTo() {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const defaultValue = (value) => {
    const date = dayjs(value);
    return date.isValid() ? date : null;
  };

  const [selectedDate, setSelectedDate] = useState(
    defaultValue(searchParams.get('DateEnd'))
  );

  const updateURLQuery = () => {
    if (!selectedDate || selectedDate === 'Invalid Date') {
      searchParams.delete('DateEnd');
    } else {
      searchParams.set('DateEnd', selectedDate.format('YYYY-MM-DD'));
    }

    navigate({ search: searchParams.toString() });
  };

  useEffect(() => {
    updateURLQuery();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  const handleChange = (newValue) => {
    setSelectedDate(defaultValue(newValue));
  };

  return (
    <Box>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box display="flex" flexDirection="column">
          <DatePicker
            value={selectedDate}
            onChange={handleChange}
            label="To Date"
            format="YYYY-MM-DD"
          />
        </Box>
      </LocalizationProvider>
    </Box>
  );
}
